// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-container[data-v-742bb57a]{height:75px;position:relative}.image-container .profile-rank[data-v-742bb57a]{align-self:flex-end;justify-self:end;position:absolute;right:0}.review-score[data-v-742bb57a]{font-size:18px}.user-info[data-v-742bb57a]{color:#8c8b8c;display:flex;margin-bottom:5px}.user-info .user-icon[data-v-742bb57a]{color:#dbdbdb;margin-right:10px;text-align:center;width:20px}.user-info .value[data-v-742bb57a]{color:#403d40}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
